@if (baseMemberSessionList?.length > 0) {
<div>
  <div class="row">
    <div class="message-instructions mb-3">
      <mwp-text-translate [text]="messageForDisplay" [jsonKey]="jsonKey" />
    </div>
    <mat-radio-group [(ngModel)]="selectedMember">
      @for (member of baseMemberSessionList; track member) {
      <div class="select-member mb-3">
        <mat-radio-button [value]="member">
          <span>{{ member.memberName }}</span>
          <mwp-text-translate text="AT" jsonKey="at" />
          <span>{{ member.companyName }}</span>
        </mat-radio-button>
      </div>
      }
    </mat-radio-group>
  </div>
  <div class="mb-3 d-flex ">
    <button class="mwp-button w-100" [disabled]="!selectedMember" (click)="submitEmit(selectedMember)">
      <mwp-text-translate text="Submit" jsonKey="submit" />
    </button>
  </div>
  <div class="mb-3 d-flex justify-content-center">
    <button class="mwp-button-secondary w-100 " (click)="cancelEmit()">
      <mwp-text-translate text="Cancel" jsonKey="cancel" />
    </button>
  </div>
</div>
}